import { render, staticRenderFns } from "./LimitedTimeRecordPopup.vue?vue&type=template&id=1c67907a&scoped=true&"
import script from "./LimitedTimeRecordPopup.vue?vue&type=script&lang=js&"
export * from "./LimitedTimeRecordPopup.vue?vue&type=script&lang=js&"
import style0 from "./LimitedTimeRecordPopup.vue?vue&type=style&index=0&id=1c67907a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c67907a",
  null
  
)

export default component.exports